import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ProgramExitTypeApiModel } from '@app/api/api-models';
import { CrudService } from '@app/api/api-services/crud.service';

@Injectable()
export class ProgramExitTypesService extends CrudService<ProgramExitTypeApiModel, number> {
  public readonly apiUrl = 'program-exit-types';

  public getPrint(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/print`, { responseType: 'blob' });
  }
}
